
<transition :mode="mode" :css="false" @enter="onEnter" @leave="onLeave" @before-enter="beforeEnter">
  <slot></slot>
</transition>
